/* MRKT Vision, Oct 2026: Complete the set in the cart drawer. (The visible search bar was removed on 23 Oct at the client's request.) */
(function () {
  /* ---------- Complete the set ---------- */
  if (!customElements.get('sev-complete-set')) {
    class SevCompleteSet extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addButton = this.querySelector('button.sev-cts__add');
        this.errorEl = this.querySelector('.sev-cts__error');
        this.selectedId = this.addButton ? this.addButton.dataset.variantId || null : null;

        this.querySelectorAll('.sev-cts__size').forEach((button) => {
          button.addEventListener('click', () => this.select(button));
        });
        if (this.addButton) this.addButton.addEventListener('click', () => this.add());
      }

      select(button) {
        if (button.disabled) return;
        this.querySelectorAll('.sev-cts__size').forEach((other) => {
          other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
        });
        this.selectedId = button.dataset.variantId;
        this.showError('');
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = !message;
      }

      async add() {
        if (!this.selectedId) {
          this.showError(this.dataset.chooseText || 'Choose a size first.');
          const firstSize = this.querySelector('.sev-cts__size:not([disabled])');
          if (firstSize) firstSize.focus();
          return;
        }

        this.addButton.disabled = true;
        this.addButton.setAttribute('aria-busy', 'true');

        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(this.selectedId), quantity: 1 }],
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Could not add to bag. Please try again.');
          }

          const drawer = document.querySelector('cart-drawer');
          if (drawer && data.sections && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
          } else {
            window.location.reload();
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sev-complete-set', cartData: data });
          }
        } catch (error) {
          this.showError(error.message);
          this.addButton.disabled = false;
          this.addButton.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('sev-complete-set', SevCompleteSet);
  }
})();
